<template>
  <div class="question-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="讨论区" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div style="position: relative;height: 100vh;overflow: scroll">
      <mt-loadmore style="font-size:0.24rem;color: #aaaaaa;position: relative" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='autoFill' bottomLoadingText = '加载更多' ref="loadmore">
        <div class="qa-section" >
          <div v-if="questionList.length>0" class="qa-list">
            <div class="question-item general-box-shadow" v-for="question in questionList" @click="toQuestionDetail(question.id)">
              <div class="question-subject">{{question.subject}}</div>
              <div class="question-image-list" v-if="question.imageArray && question.imageArray.length>0">
                <img v-for="img in question.imageArray" :src="imgUrl + img | ossProcess(200, 150)"/>
              </div>
              <div class="question-bottom">
                <div>来自&nbsp;{{question.userName || question.userPhone}}</div>
                <div class="right">
                  <div>回答&nbsp;{{question.answerCount || 0}}</div>
                  <div class="create-time">{{question.createTime| prettifyTime}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="black-page" v-if="questionList.length==0" @click="editQuestion">
            <img src="../../assets/icon-no-img.png">
            <div class="tip">暂时无人提问，去发布问题</div>
          </div>
        </div>
      </mt-loadmore>
      <div class="question-edit-btn" @click="editQuestion">
        提问
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl} from "../../config";
  import questionService from '../../service/qa/QuestionService'
  import session from '../../utils/Session'
  import envUtils from '../../utils/EnvUtils'

  export default {
    name: 'QuestionList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        questionList:[],
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        isShowSearch:false,
        showCancel:true,
        keyword:'',
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getQuestionList();
    },
    methods: {
      async getQuestionList(onCancel = function(){}){
        if(this.pageNo == 1){
          this.questionList = [];
        }
        let {code,msg,data} =await questionService.list(this.keyword,this.pageNo);
        if(code == '0'){
          for (let question of data.result){
            if(question.images){
              if(question.images.split(',').length>3){
                question.imageArray = question.images.split(',').slice(0, 3);
              }
            }
            if(!question.userName){
              question.userName = question.userPhone;
            }
            this.questionList.push(question);
          }
          this.allLoaded = data.lastPage;
          onCancel();
        }else {
          Toast(msg);
        }
      },
      async editQuestion(){
        const isLogin = await session.isLogin();
        if(isLogin){
          this.$router.push({name: 'QaEdit'});
        }else{
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            this.$router.push({name:'BindPhone'});
          }
        }
      },
      toQuestionDetail(questionId){
        this.$router.push({name: 'QaDetail',query:{questionId}});
      },
      loadBottom(){
        this.pageNo++;
        this.getQuestionList(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .question-list-page{
    padding-top: 0.32rem;
    background: white;
    .question-edit-btn{
      position: fixed;
      bottom: 1.5rem;
      right: 0.5rem;
      width: 0.88rem;
      height: 0.88rem;
      border-radius: 0.88rem;
      line-height: 0.9rem;
      background: #feac00;
      color: white;
      font-size: 0.28rem;
      text-align: center;
      letter-spacing: 2px;
      box-shadow: 0px 2px 6px 0px
      rgba(167, 75, 0, 0.57);
    }
  }
</style>
